import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Register",
		component: () => import("../views/Register.vue")
	},
	{
		path: "/agreement",
		name: "Agreement",
		component: () => import("../views/Agreement.vue")
	},
	{
		path: "/download",
		name: "Download",
		component: () => import("../views/Download.vue")
	}
];

const router = new VueRouter({
	base: process.env.NODE_ENV === "production" ? "./" : "",
	routes
});

export default router;